<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="cancel_order"
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="54"
    viewBox="0 0 54 54"
  >
    <path id="Path_8408" data-name="Path 8408" d="M0,0H54V54H0Z" fill="none" />
    <path
      id="Path_8409"
      data-name="Path 8409"
      d="M29.618,16.883,16.883,29.618m12.735,0L16.883,16.883M23.25,43.5h0A20.249,20.249,0,0,1,3,23.25H3A20.249,20.249,0,0,1,23.25,3h0A20.249,20.249,0,0,1,43.5,23.25h0A20.249,20.249,0,0,1,23.25,43.5Z"
      transform="translate(3.75 3.75)"
      fill="none"
      :stroke="clr ? clr : '#ec484a'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
  </svg>
</template>
